import React from 'react';
import TextFilter from './TextFilter';
import NumberFilter from './NumberFilter';
import DateFilter from './DateFilter';
import SelectFilter from './SelectFilter';
import UserFilter from './UserFilter';
import TimeFilter from './TimeFilter';
import FormatFilter from './FormatFilter';

export default function FilterDispatcher({ column, value, operator, onChange, onApply, users, procesos, positions }) {
  switch (column.type) {
    case 'answer_integer':
    case 'answer_formula':
    case 'dynamic_field':
      return <NumberFilter value={value} operator={operator} onChange={onChange} onApply={onApply} />;

    case 'answer_date':
    case 'answer_autdatetime':
    case 'answer_datetime':
      return <DateFilter value={value} operator={operator} onChange={onChange} />;

    case 'answer_time':
    case 'answer_hour':
      return <TimeFilter value={value} operator={operator} onChange={onChange} />;

    case 'answer_select':
    case 'answer_radio':
      return <SelectFilter value={value} operator={operator} onChange={onChange} options={column.options || []} />;

    case 'answer_checkbox':
      return <SelectFilter value={value} operator={operator} onChange={onChange} options={column.options || []} />;

    case 'answer_user_id':
      return <UserFilter value={value} operator={operator} onChange={onChange} items={(users || []).map(u => ({ id: u.id, name: u.name }))} />;

    case 'proceso_id':
      return <UserFilter value={value} operator={operator} onChange={onChange} items={(procesos || []).map(p => ({ id: p.id, name: p.name }))} />;

    case 'position_id':
      return <UserFilter value={value} operator={operator} onChange={onChange} items={(positions || []).map(p => ({ id: p.id, name: p.name }))} />;

    case 'format_id':
      return <FormatFilter value={value} operator={operator} onChange={onChange} columnId={column.id} />;

    default:
      return <TextFilter value={value} operator={operator} onChange={onChange} onApply={onApply} />;
  }
}
